import baseApi, {provideTag} from './baseApi'

const authApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        login: build.mutation({
            query: ({email, password}) => {
                return {
                    url: 'auth/login',
                    method: 'POST',
                    body: {email, password},
                }
            },
            invalidatesTags: ['CurrentUser'],
        }),
        getCurrentUser: build.query({
            query: () => ({url: 'auth/getCurrentUser', method: 'GET'}),
            transformResponse: (res) => res,
            providesTags: () => provideTag('CurrentUser'),
        }),
        logout: build.mutation({
            query: () => {
                return {
                    url: 'auth/logout',
                    method: 'POST',
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['CurrentUser'],
        }),
        setUserAccount: build.mutation({
            query: ({accountId, accountName}) => {
                return {
                    url: 'auth/setUserAccount',
                    method: 'POST',
                    body: {accountId, accountName},
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: [
                'CurrentUser',
                'Account',
                'User',
                'Structure',
                'Consumer',
                'Meter',
                'Rate',
                'MeterReading',
                'Invoice',
                'FaultLog',
                'Account_Report',
                'Invite',
                'Config',
                'DailyMeterReading',
                'CurrentRate',
                'UserAccounts',
            ],
        }),
        unsetUserAccount: build.mutation({
            query: () => {
                return {
                    url: 'auth/unsetUserAccount',
                    method: 'DELETE',
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: [
                'CurrentUser',
                'Account',
                'User',
                'Structure',
                'Consumer',
                'Meter',
                'Rate',
                'MeterReading',
                'Invoice',
                'FaultLog',
                'Account_Report',
                'Invite',
                'Config',
                'DailyMeterReading',
                'CurrentRate',
                'UserAccounts',
            ],
        }),
        signupWithInvite: build.mutation({
            query: ({token, data}) => {
                return {
                    url: `auth/signup/${token}`,
                    method: 'POST',
                    body: data,
                }
            },
            invalidatesTags: ['CurrentUser'],
        }),
        forgotPassword: build.mutation({
            query: (data) => {
                return {
                    url: 'auth/forgotPassword',
                    method: 'POST',
                    body: data,
                }
            },
        }),
        resetPassword: build.mutation({
            query: ({token, data}) => {
                return {
                    url: `auth/resetPassword/${token}`,
                    method: 'POST',
                    body: data,
                }
            },
        }),
        verifyTwoFactor: build.mutation({
            query: ({email, code}) => {
                return {
                    url: 'auth/verify-2fa',
                    method: 'POST',
                    body: {email, code},
                }
            },
            invalidatesTags: ['CurrentUser'],
        }),
    }),
    overrideExisting: false,
})

export default authApi

export const {
    useLoginMutation,
    useGetCurrentUserQuery,
    useLogoutMutation,
    useSetUserAccountMutation,
    useUnsetUserAccountMutation,
    useSignupWithInviteMutation,
    useForgotPasswordMutation,
    useResetPasswordMutation,
    useVerifyTwoFactorMutation,
} = authApi
